var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4142 3.41421C41.1953 2.63316 41.1953 1.36683 40.4142 0.585779C39.6332 -0.19527 38.3668 -0.19527 37.5858 0.585779L20.5 17.6716L3.41421 0.585779C2.63316 -0.19527 1.36683 -0.19527 0.585786 0.585779C-0.195262 1.36683 -0.195262 2.63316 0.585786 3.41421L17.6716 20.5L0.585786 37.5858C-0.195262 38.3668 -0.195262 39.6332 0.585786 40.4142C1.36683 41.1953 2.63316 41.1953 3.41421 40.4142L20.5 23.3284L37.5858 40.4142C38.3668 41.1953 39.6332 41.1953 40.4142 40.4142C41.1953 39.6332 41.1953 38.3668 40.4142 37.5858L23.3284 20.5L40.4142 3.41421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-Icon.3fdbe72e99d1ca0b6e11db6eb854be09.svg";
export { ForwardRef as ReactComponent };